export default __webpack_public_path__ + "static/media/cv_academic_fr.8e6824ce.pdf";